import React from "react";
import {
    Eye,
    Calendar,
    Home,
    MapPin,
    Briefcase,
    DollarSign
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AppraiserDashQuote } from "../api/ApiTypes.ts";
import { formatDate, formatCurrency } from "../utils/dateUtils.ts";
import {MetadataRow} from "./MetaDataRow.tsx";

export const QuoteDashboardItem: React.FC<{ quote: AppraiserDashQuote }> = ({ quote }) => {
    const navigate = useNavigate();

    return (
        <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden hover:shadow-md transition-shadow">
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className="p-2 bg-blue-50 rounded-md flex-shrink-0">
                                <Home className="h-8 w-8 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-medium text-lg lg:text-base text-slate-800 break-all">
                                    {quote.propertyAddressLine1}
                                </h3>
                                <p className="text-sm sm:text-base text-slate-500 mt-1">
                                    {quote.propertyCity}, {quote.propertyStateCode} {quote.propertyZipCode}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <button
                            onClick={() => navigate(`/appraiser/quote/${quote.id}`)}
                            className="inline-flex items-center px-3 py-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition-colors hover:cursor-pointer"
                        >
                            <Eye className="h-4 w-4 mr-1" />
                            View Request
                        </button>
                    </div>
                </div>

                <div className="mt-4 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                    <MetadataRow icon={<Calendar className="h-4 w-4 mr-1 text-blue-700" />} label={`Due:`} value={formatDate(quote.dueDate)}/>
                    <MetadataRow icon={<Briefcase className="h-4 w-4 mr-1 text-blue-700" />} label={`Client:`} value={quote.clientCompany}/>
                    <MetadataRow icon={<MapPin className="hh-4 w-4 mr-1 text-blue-700" />} label='' value={quote.propertyType}/>
                    <MetadataRow icon={<DollarSign className="h-4 w-4 mr-1 text-blue-700" />} label={`Fee:`} value={formatCurrency(quote.appraiserFee)} />
                </div>

                <div className="mt-2 flex flex-wrap gap-2">
                    <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700">
                        {quote.reportType}
                    </span>
                    <span className="inline-flex items-center rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700">
                        {quote.intendedUse}
                    </span>
                </div>
            </div>
        </div>
    );
};
